// extracted by mini-css-extract-plugin
module.exports = {"container":"Databox_container__22ET0","chart":"Databox_chart__10TV-","title":"Databox_title__2DGpv"};